import { withUserContext } from 'context'
import { Text, CustomLink, ButtonSimple, ButtonFollow, Avatar } from 'components/common'

import Location from './Location'
import Work from './Work'
import Education from './Education'
import Socials from './Socials'

const ProfileLeftBar = ({ isMyProfile, profile: { id, avatar, name, surname, location, education, socials, work } }) => {
    return (
        <div className='left flexBoxColumn'>
            <Avatar
                className='profile-pic'
                src={avatar}
                width={248}
                quality={80}
            />
            <div className='personal-info flexBoxColumn'>
                <Text tag={'p'} className={'name PopSemi'} text={`${name} ${surname}`} />

                <Location
                    location={location}
                    isMyProfile={isMyProfile}
                />
                <Work
                    work={work}
                    isMyProfile={isMyProfile}
                />
                <Education
                    education={education}
                    isMyProfile={isMyProfile}
                />
                <Socials
                    socials={socials}
                />

                {isMyProfile ? (
                    <CustomLink url={`/profile/edit`} className={`edit-follow ${!!(!work?.position || !work?.company) && 'job-info'}`}>
                        <ButtonSimple text='Edit Profile' />
                    </CustomLink>
                ) : (
                    <ButtonFollow
                        className={`purple-follow follow guest-profile ${!!(!work?.position || !work?.company) && 'job-info'}`}
                        followingId={id}
                    />
                )}
            </div>
        </div>
    )
}

export default withUserContext(ProfileLeftBar, ['toggleFollow'])
